import React from "react";
import Header from "../Component/Services/Wilo Pumps/Header";
import Products from "../Component/Services/Wilo Pumps/Products";
import QuickContact from "../Component/Services/QuickContact2";

function WiloPumps() {
  return (
    <>
      <Header />
      <Products />
      <QuickContact />
    </>
  );
}

export default WiloPumps;
